import React from 'react';
import { SocketInitializer } from 'contexts/SocketContext';
import useWorkspaceStore from '../stores/useWorkspaceStore';

export default function SocketInitializerBridge({ children }) {
  const organizations = useWorkspaceStore((s) => s.organizations);
  const selectedProjectId = useWorkspaceStore((s) => s.selectedProjectId);

  return (
    <SocketInitializer
      organizations={organizations}
      selectedProject={selectedProjectId}
    >
      {children}
    </SocketInitializer>
  );
}
